<template>
  <div>


    <el-rate
      v-model="child_defaultValue"
      :disabled="fieldArguments.disabled?fieldArguments.disabled:false"
      show-score
      :text-color="fieldArguments.text_color?fieldArguments.text_color:'#ff9900'"
      score-template="{value}"
      @change="onChange">
    </el-rate>


  </div>
</template>
<script>
  import Common from './js/Common'
  
  export default {
    name: 'rate',
    mixins:[Common],
    data () {
      return {
        inital_defaultValue:0,
        child_defaultValue:0,
      }
    },
  }
</script>
<style>
  .el-rate {
      overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/solely-fields/rate.vue